import { usePathname, type UnknownOutputParams } from 'expo-router'
import { useEffect } from 'react'

import { GTM } from '@/src/general/utils/gtm'
import { EVENTS } from '@/src/general/utils/gtm/constants'

export const usePageViewAnalyticsTracking = (searchParams: UnknownOutputParams) => {
  const pathname = usePathname()
  const formattedPathname = pathname.split('/')[1]
  const ids = Object.entries(searchParams).reduce<string>(
    (acc, [key, value]) =>
      key.toLowerCase().includes('id') ? `${acc}-${Array.isArray(value) ? value.join(',') : value}` : acc,
    '',
  )

  useEffect(() => {
    GTM.sendEvent({ event: EVENTS.PAGEVIEW })
  }, [formattedPathname, ids])
}
